
import { Component, Mixins, Prop } from "vue-property-decorator";
import SummaryMixin from "@/views/summary/summary.mixin";
import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify"

const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: false
});

@Component
export default class AiInsight extends Mixins(SummaryMixin) {
  @Prop() aiInsightShow!: boolean;
  @Prop() participantId!: number;
  @Prop() observationDate!: string;
  @Prop() firstName!: string;
  @Prop() lastName!: string;
  @Prop() clientId!: number;

  loading = false;
  currentLoadingStepIndex = 0;
  loadingStepTimer?: number;

  loadingSteps = [
    {
      title: "Checking Safety Alerts..."
    },
    {
      title: "Detecting Recent Deviation..."
    },
    {
      title: "Evaluating Current Pattern..."
    },
    {
      title: "Reviewing Engagement..."
    },
    {
      title: "Generating Recovery Insights..."
    }
  ];

  get currentLoadingStep() {
    return this.loadingSteps[this.currentLoadingStepIndex];
  }

  get synopsisHtml() {
    const text = this.participantSynopsisResponse?.synopsis ?? "";
    const rawHtml = md.render(text);
    return DOMPurify.sanitize(rawHtml);
  }

  async mounted() {
    this.loading = true;
    this.startLoadingSequence();
    try {
      await this.fetchData();
    } finally {
      this.stopLoadingSequence();
      this.loading = false;
    }
  }

  beforeDestroy() {
    this.stopLoadingSequence();
  }

  async fetchData() {
    const fetch = [
      this.$store.dispatch("Summary/fetchAiInsight", {
        participantId: this.participantId, 
        clientId: this.clientId,
        timezone: this.selectedClient.timezone
      })
    ];
    await Promise.all(fetch);
  }

  startLoadingSequence() {
    this.currentLoadingStepIndex = 0;
    this.stopLoadingSequence();
    this.loadingStepTimer = window.setInterval(() => {
      if (this.currentLoadingStepIndex < this.loadingSteps.length - 1) {
        this.currentLoadingStepIndex += 1;
      }
    }, 2600);
  }

  stopLoadingSequence() {
    if (this.loadingStepTimer) {
      window.clearInterval(this.loadingStepTimer);
      this.loadingStepTimer = undefined;
    }
  }

  closeModal() {
    this.stopLoadingSequence();
    this.$emit('update:aiInsightShow', false);
  }
}
